import { render, staticRenderFns } from "./StepProp.vue?vue&type=template&id=fa1313a6&scoped=true"
import script from "./StepProp.vue?vue&type=script&lang=js"
export * from "./StepProp.vue?vue&type=script&lang=js"
import style0 from "./StepProp.vue?vue&type=style&index=0&id=fa1313a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1313a6",
  null
  
)

export default component.exports